import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const TabViewTailwindThemes = {
  tabview: {
    navContainer: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames('relative', { 'overflow-hidden': props.scrollable }),
    }),
    navContent: 'overflow-y-hidden overscroll-contain overscroll-auto scroll-smooth',
    previousButton: {
      className: classNames(
        'h-full flex items-center justify-center !absolute top-0 z-20',
        'left-0',
        'bg-white text-black w-12 shadow-lg rounded-none',
      ),
    },
    nextButton: {
      className: classNames(
        'h-full flex items-center justify-center !absolute top-0 z-20',
        'right-0',
        'text-black w-12 shadow-lg rounded-none',
      ),
    },
    nav: {
      className: classNames('flex flex-1 gap-1 list-none bg-transparent'),
    },
    panelContainer: 'mt-3',
  },
  tabpanel: {
    header: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames('p-1', {
        'cursor-default pointer-events-none select-none user-select-none opacity-60': props?.disabled,
      }),
    }),
    headerAction: {
      className: classNames(
        'items-center cursor-pointer flex overflow-hidden relative select-none text-decoration-none user-select-none',
        'px-[24px] py-[8px]',
        'transition-colors transition-shadow duration-200',
        'outline-transparent',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fletchers-green-500',
        '[[aria-selected="true"]]:text-fletchers-green-500 [[aria-selected="true"]]:border-b-1 [[aria-selected="true"]]:border-fletchers-green-500',
        '[[aria-selected="false"]]:text-black',
      ),
    },
    headerTitle: {
      className: classNames('text-[0.75rem] whitespace-nowrap'),
    },
  },
};
